import styled from 'styled-components';

const BreadcrumbsWrapper = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
    margin-left: ${({ theme }) => theme.spacing(1)};
`;

export { BreadcrumbsWrapper };
